<script setup>
const { locale } = useI18n();
const localePath = useLocalePath();

const props = defineProps(['data']);
</script>

<template>
  <div>
    <div class="b-flex">
      <div v-for="(item, key) in data" :key="key" class="logo">
        <nuxt-link
          :to="
            localePath({
              name: 'about-partners-slug',
              params: { slug: item.slug[locale] },
            })
          "
        >
          <img :src="useGetImageUrl(item.image, 200)" :alt="item.name" class="gallery__image" />
        </nuxt-link>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<style lang="scss" scoped>
figure {
  width: auto !important;
}

.swiper-wrapper {
  align-items: center;
}

.gallery__items {
  margin: 0 !important;
}

.gallery__image {
  @include mq($sm, true) {
    max-width: 100px;
  }
}

.logo {
  height: 60px;
  width: 160px !important;
  margin-right: 1rem;
  width: auto;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}
</style>
